import { render, staticRenderFns } from "./BodyReportCard.vue?vue&type=template&id=5ff83fde&scoped=true"
import script from "./BodyReportCard.vue?vue&type=script&lang=js"
export * from "./BodyReportCard.vue?vue&type=script&lang=js"
import style0 from "./BodyReportCard.vue?vue&type=style&index=0&id=5ff83fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff83fde",
  null
  
)

export default component.exports